/**
 * Seitenleiste ab Tablettbreite.
 *
 * Zeigt die vierzehn Desktop-Bereiche aus Kapitel 38. Ab dieser Breite wird
 * überwiegend an breiten Tabellen gearbeitet (Angebotsvergleich,
 * Rechnungsprüfung) — dort ist eine dauerhaft sichtbare Navigation richtig,
 * während sie auf dem Telefon Platz kostet, der der Arbeit fehlt.
 */
import { Link } from "@tanstack/react-router";

import { t } from "@/i18n";
import { cn } from "@/lib/cn";

import { DESKTOP_NAV } from "./navigation";

const ITEM_BASE = cn(
  "flex min-h-touch w-full items-center gap-3 rounded-card px-2.5 text-left",
  "text-[0.9375rem] transition-colors",
);

export function SideNav() {
  return (
    <nav
      aria-label={t.nav.ariaSide}
      className="hidden w-60 shrink-0 flex-col gap-5 overflow-y-auto border-r border-line bg-surface-raised px-3 py-4 md:flex"
    >
      <div className="flex items-center gap-2 px-1.5">
        <img src="/icon.svg" alt="" width={26} height={26} className="rounded" />
        <span className="text-[1.0625rem] font-semibold tracking-tight text-ink">{t.app.name}</span>
      </div>

      {DESKTOP_NAV.map((group) => (
        <div key={group.label} className="flex flex-col gap-0.5">
          <p className="section-label px-1.5 pb-1">{group.label}</p>

          {group.entries.map((entry) => (
            <Link
              key={entry.id}
              to={entry.to}
              activeOptions={{ exact: entry.to === "/" }}
              className={cn(
                ITEM_BASE,
                "text-ink-muted hover:bg-surface-sunken",
                "data-[status=active]:bg-surface-sunken data-[status=active]:font-semibold",
                "data-[status=active]:text-ink",
              )}
            >
              <entry.icon className="size-5 shrink-0" />
              <span className="truncate">{entry.label}</span>
              {/* Punkt statt Text: In einer schmalen Leiste wäre eine
                  Erläuterung abgeschnitten. Er steht nur an einem Bereich, in
                  dem die Ansicht schon da ist und die Daten noch fehlen —
                  derzeit an keinem. */}
              {entry.pending === true && (
                <span
                  aria-hidden="true"
                  className="ml-auto size-1.5 shrink-0 rounded-full bg-line-strong"
                />
              )}
            </Link>
          ))}
        </div>
      ))}
    </nav>
  );
}
